import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "@core/services/base.service";
import { LoadingService } from "@core/services/loading.service";
import { environment } from "@env/environment";
import {
  AbuseReportRequestInterface,
  AbuseReportCheckResponseInterface
} from "@shared/interfaces/abuse-report.interface";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class AbuseReportApiService extends BaseService {
  private readonly apiUrl = `${environment.classicApiUrl}/api/v2/common/abuse-reports`;

  constructor(
    public readonly loadingService: LoadingService,
    private readonly http: HttpClient
  ) {
    super(loadingService);
  }

  /**
   * Submit an abuse report for any content type
   */
  submitReport(data: AbuseReportRequestInterface): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/`, data);
  }

  /**
   * Check if a topic has an abuse report
   */
  checkTopic(topicId: number): Observable<AbuseReportCheckResponseInterface> {
    const params = new HttpParams().set("topic_id", topicId.toString());
    return this.http.get<AbuseReportCheckResponseInterface>(`${this.apiUrl}/check-topic/`, { params });
  }

  /**
   * Check if a post has an abuse report
   */
  checkPost(postId: number): Observable<AbuseReportCheckResponseInterface> {
    const params = new HttpParams().set("post_id", postId.toString());
    return this.http.get<AbuseReportCheckResponseInterface>(`${this.apiUrl}/check-post/`, { params });
  }
}
